'use client';

import { useAction, useAtom } from '@reatom/npm-react';
import { loadLikesAction } from '@trwl/store';
import { loadCartAction } from '@trwl/store/actions';
import { isAuthedAtom } from '@trwl/store/atoms';
import { usePathname } from 'next/navigation';
import { PropsWithChildren, useEffect } from 'react';

export const LoadDataProvider = ({ children }: PropsWithChildren) => {
  const pathname = usePathname();
  const loadCart = useAction(loadCartAction);
  const loadLikes = useAction(loadLikesAction);
  const [isAuthed] = useAtom(isAuthedAtom);

  useEffect(() => {
    if (!isAuthed) return;
    const action = () => {
      loadCart();
      loadLikes();
    };
    const timeout = setTimeout(action, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [isAuthed, loadCart, loadLikes, pathname]);

  return children;
};
